import React from 'react';
import PropTypes from 'prop-types';

const AnimationPlayer = props => {
  const { autoplay, started, ended, source, width, height, poster } = props;
  const vidRef = props.passedRef || React.createRef();
  const handlePlay = () => {
    props.canReplay && vidRef.current.play();
  };

  return (
    <video
      width={width}
      height={height}
      ref={vidRef}
      autoPlay={autoplay}
      data-test="video-element"
      poster={poster}
      onPlay={() => started && started()}
      onEnded={() => ended()}
      onClick={handlePlay}
    >
      <source src={source} type={'video/mp4'} />
    </video>
  );
};

AnimationPlayer.defaultProps = { autoplay: false, canReplay: true };

AnimationPlayer.propTypes = {
  autoplay: PropTypes.bool,
  canReplay: PropTypes.bool,
  ended: PropTypes.func,
  height: PropTypes.number,
  passedRef: PropTypes.shape({ current: PropTypes.object }),
  poster: PropTypes.string,
  source: PropTypes.string,
  started: PropTypes.func,
  width: PropTypes.number
};

export default AnimationPlayer;
